// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"f42cc8bb","485":"ed077c56","840":"dc4adc0c","954":"dc4adc0c"}[chunkId] + ".chunk.css";
};